import {
  GetAnswersForMetricsOnCompanyLevelQuery_,
  GetAnswersForMetricsOnGroupLevelQuery_,
  GetAssessmentCurrencyConversionQuery_,
  GetCompanyLevelMdrmAnswersQuery_,
} from 'models';
import {
  getAggregatedMetricAnswers,
  getMetricAnswers,
  MetricsTableData,
  MetricType,
  MdrmTypeEnum,
} from '../DisclosureRequirements';
import { ReportMetric } from './Report.types';
import { AssessableMetrics } from '../DisclosureRequirements/Metrics/Metrics';
import { sanitizeText } from './DocGenerator/report-helper-functions';

export const getMetricResult = (data: {
  metric: AssessableMetrics[number];
  nestedMetric: MetricsTableData;
  isGroup: boolean;
  materialStandardId: string;
  reportingUnitsAnswers?: GetAnswersForMetricsOnCompanyLevelQuery_;
  groupAnswers?: GetAnswersForMetricsOnGroupLevelQuery_;
  standardRef?: string;
  currencyConversionData?: GetAssessmentCurrencyConversionQuery_['esrs_AssessmentCurrencyConversion'];
}) => {
  const {
    metric,
    nestedMetric,
    isGroup,
    materialStandardId,
    reportingUnitsAnswers,
    groupAnswers,
    standardRef,
    currencyConversionData,
  } = data;

  const subsidiaries = groupAnswers?.EsrsAssessment_by_pk?.subsidiaryAssessments ?? [];
  const reportingUnits = reportingUnitsAnswers?.EsrsAssessment_by_pk?.reportingUnits ?? [];

  const answers = getMetricAnswers({
    metric,
    companyAnswersData: reportingUnits,
    groupAnswersData: subsidiaries,
    isGroup,
    standardRef,
    materialStandardId,
  });

  const filteredAnswers = answers.filter((a) => !a.metric.childrenMetrics?.length);

  const result = getAggregatedMetricAnswers(
    nestedMetric,
    isGroup,
    filteredAnswers,
    subsidiaries,
    currencyConversionData
  );
  return result;
};

type ReportMdrmAnswerType = GetCompanyLevelMdrmAnswersQuery_['esrs_DatapointMdrm'][number];
export type ReportMdrmMetricAnswers = {
  metric: MetricType;
  answers: {
    metricUsed: ReportMdrmAnswerType | undefined;
    methodology: ReportMdrmAnswerType | undefined;
    validation: ReportMdrmAnswerType | undefined;
    entitySpecific: ReportMdrmAnswerType | undefined;
  };
};

export const getMetricMdrmAnswers = (
  metric: ReportMetric,
  mdrmAnswers?: GetCompanyLevelMdrmAnswersQuery_['esrs_DatapointMdrm']
): ReportMdrmMetricAnswers => {
  const answers = mdrmAnswers
    ?.filter((mdrmA) => mdrmA.datapoint.answer.metricRef === metric?.reference)
    .map((mdrmA) => ({ ...mdrmA, value: sanitizeText(mdrmA.value) }));
  const metricAnswers = {
    metric: metric as unknown as MetricType,
    answers: {
      metricUsed: answers?.find((a) => a.mdrmRef === MdrmTypeEnum.metricUsed),
      methodology: answers?.find((a) => a.mdrmRef === MdrmTypeEnum.methodology),
      validation: answers?.find((a) => a.mdrmRef === MdrmTypeEnum.validation),
      entitySpecific: answers?.find((a) => a.mdrmRef === MdrmTypeEnum.entitySpecific),
    },
  };
  return metricAnswers;
};
